import { CEBlockAttributesBase } from './ce-block-attributes-base'


export class CEBlockAttributes extends CEBlockAttributesBase {

}